import { Cmr } from "../../models/Cmr";
import { OptionType } from "../../stores/form/Interface";

export default function initialValues(
  entity: Cmr,
  clients: OptionType[],
  departments: OptionType[]
): Object {
  return {
    ...entity,
    user_id: clients.some((item) => item.value === entity.user_id)
      ? entity.user_id
      : null,
    department_id: departments.some(
      (item) => item.value === entity.department_id
    )
      ? entity.department_id
      : null,
  };
}
